import { hideVisually } from 'polished'
import { forwardRef } from 'react'

import theme from 'theme'

const Menu = forwardRef<HTMLUListElement, { isOpen: boolean }>(
  ({ isOpen, ...rest }, ref) => (
    <ul
      ref={ref}
      css={[
        !isOpen && hideVisually(),

        {
          position: 'absolute',
          right: 0,
          top: 'calc(100% + 4px)',
          minWidth: theme.space[8],
          border: theme.border.base,
          paddingTop: theme.space[2],
          paddingBottom: theme.space[2],
          borderRadius: theme.borderRadius[0],
          backgroundColor: 'white',
          zIndex: theme.zIndices[1],
          maxHeight: 300,
          overflowY: 'auto',
          textAlign: 'left',
          listStyle: 'none',
          boxShadow: theme.boxShadows.small
        },

        isOpen && {
          borderColor: theme.colors.gray[1]
        }
      ]}
      {...rest}
    />
  )
)

Menu.displayName = 'Menu'

export default Menu
